import { Button } from "@heroui/react";
import { bodyMuted, btnPrimary, eyebrow, glow } from "@/components/ui/design";

export default function Error500() {
    return (<div className="relative isolate flex min-h-[700px] flex-col items-center justify-center overflow-hidden bg-white px-4 py-20 text-center dark:bg-nightBg">
        <div className={glow} />
        <img src="/500error.svg" className="h-[120px] w-[120px] opacity-90 sm:h-[156px] sm:w-[156px]" />
        <div className="mt-8 text-[clamp(96px,22vw,220px)] font-bold leading-[0.85] tracking-[-0.06em] text-grey10 dark:text-white">500</div>
        <div className={`${eyebrow} mt-6`}>Internal server error</div>
        <div className={`${bodyMuted} mt-3 mb-8 font-semibold`}>Please try again later.</div>
        <Button onPress={() => window.location.href = '/'} variant="flat" className={btnPrimary}>Homepage</Button>
    </div>)
}
